import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// 定義 enum-like 物件
export const ToastType = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warn",
};

class ToastAlert {
  constructor() {
    this.toastId = null;
    this.options = this._initOptions();
  }

  showInfo(msg) {
    // this.options = {
    //   ...this.options,
    //   render: msg,
    //   type: ToastType.INFO,
    //   autoClose: this.options.autoClose ? 2000 : this.options.autoClose,
    //   closeOnClick: this.options.autoClose,
    // };
    // this._show();
    this._show(msg, ToastType.INFO, 2000);
  }

  showError(msg) {
    this._show(msg, ToastType.ERROR, 3000);
  }

  showSuccess(msg) {
    this._show(msg, ToastType.SUCCESS, 2000);
  }

  showWarning(msg) {
    this._show(msg, ToastType.WARNING, 2000);
  }

  autoClose(auto = true) {
    this.options.autoClose = auto;
    return this;
  }

  dismiss() {
    toast.dismiss(this.toastId);
  }

  _show(msg, type, autoCloseMs) {
    if (this.toastId) toast.dismiss(this.toastId);

    this.toastId = toast(msg, {
      ...this.options,
      type: type,
      autoClose: this.options.autoClose ? autoCloseMs : this.options.autoClose,
    });

    this.options = this._initOptions(); // 重置 options
  }

  _initOptions() {
    return {
      autoClose: true,
    };
  }
}

const toastAlert = new ToastAlert();
export default toastAlert;
